import { HttpEventType } from '@angular/common/http';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { BehaviorSubject, firstValueFrom, lastValueFrom, Subject, Subscription } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { CustomTableSelectComponent } from 'src/app/components/custom-table-select/custom-table-select.component';
import { AccountingInterfaceEnums } from 'src/app/enum/accounting-interface-enums';
import { StatusDianEnums } from 'src/app/enum/electronic-document-enums';
import { ActionColor, CheckBoxAction, TableAction } from 'src/app/interfaces/custom-table/custom-table-action.interface';
import { FormatModel } from 'src/app/models/formats/format.model';
import { ElectronicInvoiceInterfaceModel } from 'src/app/models/invoicing/electronic-invoice-interface.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { ElectronicInvoiceInterfaceDetailCaptureTableModel } from 'src/app/models/tables/invoicing/electronic-invoice-interface-detail-capture-table.model';
import { ElectronicDocumentService } from 'src/app/services/invoicing/electronic-document.service';
import { ElectronicInvoiceInterfaceService } from 'src/app/services/invoicing/electronic-invoice-interface.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import Swal from 'sweetalert2';
import { SendMailComponent } from '../../electronic-invoice-interface/send-mail/send-mail.component';

@Component({
  selector: 'app-electronic-invoice-interface-detail',
  templateUrl: './electronic-invoice-interface-detail.component.html',
  styleUrls: ['./electronic-invoice-interface-detail.component.scss'],
  standalone: false
})
export class ElectronicInvoiceInterfaceDetailComponent implements OnInit {
  @ViewChild('sendEmail') sendEmailComponent?: CustomModalComponent | null = null;
  @ViewChild('documentsSelection') documentSelectionModalComponent?: CustomModalComponent | null = null;

  @Input('electronicInvoiceInterfaceModel')
  set changeInterface(changeInterface: ElectronicInvoiceInterfaceModel) {
    this.changeElectronicInvoiceInterface(changeInterface);
  }
  @Input() companyId: number = 0;
  @Input() permissionUpdatable: boolean = false;
  @Input() listBranches: any[] = [];
  @Input() listEnterprises: any[] = [];
  ascendant: boolean = true;
  columnSort: string | null = null;
  checkboxActions: CheckBoxAction[] = [
    {
      label: 'Eliminar',
      icon: 'pi pi-trash',
      color: ActionColor.DANGER,
      action: 'bulk-delete'
    },
  ];
  componentTableSelection = CustomTableSelectComponent;
  detailData: PagedResponseModel<ElectronicInvoiceInterfaceDetailCaptureTableModel> = new PagedResponseModel<ElectronicInvoiceInterfaceDetailCaptureTableModel>();
  detailDataModal: PagedResponseModel<ElectronicInvoiceInterfaceDetailCaptureTableModel> = new PagedResponseModel<ElectronicInvoiceInterfaceDetailCaptureTableModel>();
  detailHeader: ColumnResponseModel[] = [];
  disabledButton: boolean = false;
  filters: ColumnResponseModel[] = [];
  formatModel: FormatModel = new FormatModel();
  inputsForDocumentsSelection$ = new BehaviorSubject<any>({
    headers: [],
    data: [],
    showCheckbox: false,
    showRecover: true,
    isMultipleSelect: true,
    filters: [],
  });
  limit: number = 200;
  nameBranch: string = '';
  page: number = 1;
  output$ = new Subject<any>();
  tableActions: TableAction[] = [
    {
      label: 'Descargar PDF',
      icon: 'pi pi-file-pdf',
      action: 'download-pdf'
    }, {
      label: 'Reenviar',
      icon: 'pi pi-envelope',
      action: 'forward'
    }
  ];

  visibleProgressBar: boolean = false;
  listElectronicInvoiceInterface: any[] = [];
  componentSendEmail = SendMailComponent;
  inputsForSendEmail$ = new BehaviorSubject<any>({
    electronicInvoiceInterfaceModel: ElectronicInvoiceInterfaceModel,
    permissionUpdatable: 0,
    dataRecover: {}
  });
  outputForSendEmail$ = new Subject<any>();
  electronicInvoiceInterfaceContract: ElectronicInvoiceInterfaceModel = new ElectronicInvoiceInterfaceModel();
  subscription: Subscription;

  constructor(private electronicInvoiceInterfaceService: ElectronicInvoiceInterfaceService,
    private electronicDocumentService: ElectronicDocumentService,
    private toastHandlerService: ToastHandlerService,
  ) { }

  async ngOnInit() {
    await this.getColumns();

    this.subscription = this.outputForSendEmail$.subscribe(async ({ type }) => {
      switch (type) {
        case 'update':
          this.getElectronicInvoiceInterfaceDetailById(false)
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });

    this.subscription = this.output$.subscribe(({ type, payload }) => {
      switch (type) {
        case 'onPageChange':
          this.onPageChange(payload, true);
          break;
        case 'onFilterChange':
          this.onFilterChange(payload);
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    })
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  changeElectronicInvoiceInterface(changeInterface: ElectronicInvoiceInterfaceModel) {
    this.electronicInvoiceInterfaceContract = changeInterface;

    if (this.electronicInvoiceInterfaceContract.electronicInvoiceInterfaceId != 0) {
      this.getElectronicInvoiceInterfaceDetailById(false);
      this.page = 1;
      this.disabledButton = false;
    } else {
      this.detailData = new PagedResponseModel<ElectronicInvoiceInterfaceDetailCaptureTableModel>();
      this.disabledButton = true;
    }
  }

  deleteHeaderNames() {
    return this.detailHeader.filter(column => column.propertyName !== 'clientBusinessName' && column.propertyName !== 'costCenterName'
      && column.propertyName !== 'providerBusinessName');
  }

  async generatePdfFiles(documentIds: number[]) {

    this.visibleProgressBar = true;
    this.listElectronicInvoiceInterface
    try {
      await firstValueFrom(this.electronicInvoiceInterfaceService.getDocumentsForGeneratePdfAsync(this.electronicInvoiceInterfaceContract.electronicInvoiceInterfaceId, documentIds));
      await this.getElectronicInvoiceInterfaceDetailById(false);
      this.toastHandlerService.showToast('success', 'Los PDF se generaron exitosamente.', '');
    } catch (error) {
      console.error('Error al generar los PDF:', error);
    }
    this.visibleProgressBar = false;
  }

  async handleSelectedItem(selectedItem: any) {
    if (selectedItem.length > 0) {
      const result = await Swal.fire({
        title: 'Atención',
        html: '¿Realmente desea generar documentos pdf?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si',
        cancelButtonText: 'No'
      });

      if (!result.isConfirmed) return;
      const documentsIds = selectedItem.map((d: { documentId: any; }) => d.documentId);
      this.generatePdfFiles(documentsIds);
    }
  }

  async downloadPdf(documentModel: ElectronicInvoiceInterfaceDetailCaptureTableModel) {
    if (documentModel.electronicInvoiceInterfaceDetailType == AccountingInterfaceEnums.documentoSoporte
      || documentModel.electronicInvoiceInterfaceDetailType == AccountingInterfaceEnums.notaAjusteDocumentoSoporte) {
      this.toastHandlerService.showToast('warning', 'La descarga de PDF para documentos de soporte no está disponible.', 'Atención');
      return;
    }

    if (documentModel.dateDocumentPdf == null) {
      this.toastHandlerService.showToast('warning', 'El PDF de este documento no ha sido generado. Por favor, genere el PDF antes de intentar descargarlo.', 'Atención');
      return;
    }

    const isInvoice = documentModel.electronicInvoiceInterfaceDetailType === AccountingInterfaceEnums.factura;
    const label = isInvoice ? 'factura' : 'nota';
    const errorMessage = `Lamentablemente, no fue posible llevar a cabo el proceso de descarga del PDF de la ${label}.`;

    try {
      this.electronicDocumentService.downloadPdfAsync(documentModel).subscribe(data => {
        switch (data.type) {
          case HttpEventType.Response: {
            const downloadedFile = new Blob([data.body!], { type: data.body!.type });
            const a = document.createElement('a');
            a.setAttribute('style', 'display:none;');
            document.body.appendChild(a);
            a.download = `${documentModel.xmlName}.pdf`;
            a.href = URL.createObjectURL(downloadedFile);
            a.target = '_blank';
            a.click();
            document.body.removeChild(a);
            break;
          }
        }
      });
    } catch (error) {
      this.toastHandlerService.showToast('error', errorMessage, 'Atención');
      console.error('Error en downloadPdf', error);
    }
  }

  async getColumns() {
    try {
      this.detailHeader = await lastValueFrom(this.electronicInvoiceInterfaceService.getColumnsForDetailCapture());
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta.', error);
    }
  }

  async getElectronicInvoiceInterfaceDetailById(updateInputs: boolean) {
    try {
      if (updateInputs) {
        this.detailDataModal = await firstValueFrom(this.electronicInvoiceInterfaceService.getElectronicInvoiceInterfaceDetailById(this.electronicInvoiceInterfaceContract.electronicInvoiceInterfaceId, this.page, this.limit, this.columnSort, this.ascendant, this.filters));
        this.updateInputs();
      } else {
        this.detailData = await firstValueFrom(this.electronicInvoiceInterfaceService.getElectronicInvoiceInterfaceDetailById(this.electronicInvoiceInterfaceContract.electronicInvoiceInterfaceId, this.page, this.limit, this.columnSort, this.ascendant, []));
      }
    } catch (error) {
      console.error('Error al buscar los documentos de la interfaz de factura electrónica.', error);
    }
  }

  async onAction(event: { action: string, item?: ElectronicInvoiceInterfaceDetailCaptureTableModel, selectedItems?: number[] }) {
    if (event.action === 'forward') {
      this.resendEmail(event.item!)
    } else if (event.action === 'download-pdf') {
      this.downloadPdf(event.item!)
    }
  }

  async onPageChange(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }, filter: boolean) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField || null;
    this.ascendant = event.sortOrder === 1;
    this.getElectronicInvoiceInterfaceDetailById(filter);
  }

  async onFilterChange(event: { filters: any }) {
    const filters = event.filters
      .map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index)
      .map((item: any) => item.value);
    this.filters = this.removeDuplicates(filters);
    this.filters.forEach((filter: any) => this.processFilter(filter));
    await this.getElectronicInvoiceInterfaceDetailById(true);
    await this.updateInputs();
  }

  async openSendEmail() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('warning', 'El usuario no tiene permisos para crear interfaz de factura electrónica. Comuníquese con el administrador del sistema.', 'Atención');
      return;
    }

    this.inputsForSendEmail$.next({
      electronicInvoiceInterfaceModel: this.electronicInvoiceInterfaceContract,
      permissionUpdatable: this.permissionUpdatable,
      dataRecovery: {
        listBranches: this.listBranches,
        listEnterprises: this.listEnterprises
      }
    });
    this.sendEmailComponent && this.sendEmailComponent.show();
  }

  async openDocumentsSelectionModal() {
    this.page = 1;
    await this.getElectronicInvoiceInterfaceDetailById(true);
    await this.updateInputs();
    this.documentSelectionModalComponent && this.documentSelectionModalComponent.show();
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filters = this.filters.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filters.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

  rejectedDianRowClass = (item: ElectronicInvoiceInterfaceDetailCaptureTableModel): string =>
    item.validationDian === StatusDianEnums.rechazado ? 'danger-row' : '';

  async resendEmail(document: ElectronicInvoiceInterfaceDetailCaptureTableModel) {
    const isInvoice = document.electronicInvoiceInterfaceDetailType === AccountingInterfaceEnums.factura;
    const isNote = document.electronicInvoiceInterfaceDetailType === AccountingInterfaceEnums.notaCredito ||
      document.electronicInvoiceInterfaceDetailType === AccountingInterfaceEnums.notaDebito;

    if (!isInvoice && !isNote) return;

    const label = isInvoice ? 'factura' : 'nota';
    const sendAction = isInvoice
      ? () => lastValueFrom(this.electronicDocumentService.resendEmailInvoice(document.documentId))
      : () => lastValueFrom(this.electronicDocumentService.resendEmailNote(document.documentId));

    const confirmHtml = `¿Está seguro de que desea reenviar el correo electrónico de la ${label} seleccionada?`;
    const successMessage = `El reenvío de la ${label} se ha completado exitosamente.`;
    const errorMessage = `Lamentablemente, no fue posible llevar a cabo el proceso de reenvío de la ${label}.`;

    const result = await Swal.fire({
      title: 'Atención',
      html: confirmHtml,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si',
      cancelButtonText: 'No'
    });

    if (!result.isConfirmed) return;

    try {
      await sendAction();
      await this.getElectronicInvoiceInterfaceDetailById(false);
      this.toastHandlerService.showToast('success', successMessage, '');
    } catch (error) {
      this.toastHandlerService.showToast('error', errorMessage, 'Atención');
      console.error('Error en resendEmail', error);
    }
  }


  async updateInputs() {

    const detailHeader = this.deleteHeaderNames();
    this.inputsForDocumentsSelection$.next({
      headers: detailHeader,
      data: this.detailDataModal,
      showCheckbox: true,
      showRecover: true,
      isMultipleSelect: true,
      filters: this.filters
    });
  }


}